import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs2 from "./page_us/Solution-US-2/SectionUs2.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
    useEffect(() => {
  const previousTitle = document.title;
  const pageUrl = "https://unik-system.com/structure-metallique-maroc";
  const imageUrl =
    "https://unik-system.com/static/media/23Architecture.a911a6885b023b8cc9a6.webp";

  // ========= HELPER =========
  const manageTag = (name, content, isProperty = false) => {
    const attr = isProperty ? "property" : "name";
    let tag = document.querySelector(`meta[${attr}='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attr, name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content.trim().replace(/\s+/g, " "));
  };

  // ========= TITLE =========
  document.title =
    "Structure Métallique Maroc | Charpente & Architecture – UNIK SYSTEM";

  // ========= META =========
  manageTag(
    "description",
    "Structure métallique au Maroc : charpente acier, solutions sur mesure pour bâtiments industriels et commerciaux."
  );

  manageTag(
    "keywords",
    "structure metallique maroc, charpente metallique maroc, structure acier maroc, construction metallique maroc"
  );

  manageTag("robots", "index, follow");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = pageUrl;

  // ========= OPEN GRAPH =========
  manageTag("og:title", document.title, true);
  manageTag(
    "og:description",
    "Conception de structures métalliques modernes au Maroc.",
    true
  );
  manageTag("og:image", imageUrl, true);
  manageTag("og:url", pageUrl, true);
  manageTag("og:type", "website", true);

  // ========= SCHEMA CLEAN =========
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        name: "UNIK SYSTEM",
        url: "https://unik-system.com",
        image: imageUrl,
        address: {
          "@type": "PostalAddress",
          addressLocality: "Casablanca",
          addressCountry: "MA"
        },

        // ⭐ FIX ERROR HERE
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          reviewCount: "20"
        },

        review: [
          {
            "@type": "Review",
            author: {
              "@type": "Person",
              name: "Client Maroc"
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5"
            },
            reviewBody:
              "Très bonne qualité de structure métallique, service professionnel."
          }
        ]
      },

      {
        "@type": "Service",
        name: "Structure métallique Maroc",
        description:
          "Fabrication et installation de structures métalliques et charpentes acier.",
        provider: {
          "@type": "Organization",
          name: "UNIK SYSTEM"
        },
        areaServed: {
          "@type": "Country",
          name: "Morocco"
        }
      },

      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Accueil",
            item: "https://unik-system.com"
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Structure métallique",
            item: pageUrl
          }
        ]
      }
    ]
  };

  let script = document.querySelector("#schema-clean");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-clean";
    document.head.appendChild(script);
  }

  script.innerHTML = JSON.stringify(schema);

  return () => {
    document.title = previousTitle;
    if (script) script.remove();
  };
}, []);




  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs2/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;